import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'grade-level-section'
const initialState = {
  list: null,
}

export const search = createApiAction(
  'grade-level-section/search',
  client.search('/api/setting/grade-level-section'),
)
export const get = createApiAction(
  'grade-level-section/get',
  client.retrieve(`/api/setting/grade-level-section/:id`),
)
export const save = createApiAction(
  'grade-level-section/save',
  client.save('/api/setting/grade-level-section'),
)
export const destroy = createApiAction(
  'grade-level-section/delete',
  client.destroy('/api/setting/grade-level-section/:id'),
)

const update = (state, action) => {
  const found = state.list?.find(rec => rec.id === action.payload.id)
  state.list = found
    ? state.list.map(item => (found.id === item.id ? action.payload : item))
    : [...state.list, action.payload]
}

const sessionSlice = createSlice({
  name,
  initialState,
  extraReducers(builder) {
    builder
      .addCase(search.fulfilled, (state, action) => {
        state.list = action.payload
      })
      .addCase(get.fulfilled, update)
      .addCase(save.fulfilled, update)
      .addCase(destroy.fulfilled, (state, action) => {
        state.list = state.list.filter(item => item.id !== action.payload.id)
      })
  },
})
export default sessionSlice.reducer
